import React from 'react'

export default function ComparisonDetalingTable({ tableData }) {
  return (
    <>
      <section className="comparisondetalin-table-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 comparisondetalin-table-pedding">
              <div className="comparisondetalin-table-main">
                <table>
                  <thead>
                    <tr>
                      {tableData?.columns?.map((title, index) => (
                        <th key={index}>{title}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {tableData?.rows?.map((row, ind) => (
                      <tr key={ind}>
                        <td>{row?.feature}</td>
                        {row?.values.map((val, indd) => (
                          <td key={indd}>{
                            val?.content ? val.content : val?.type === "Yes" ? 
                            (<><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> {val.type} </> ): 
                            (<><img src="/assets/images/check-icon-no.webp" alt="No" /> {val.type} </>)
                            }</td>
                        ))}
                      </tr>
                    ))}

                    {/* <tr>
                      <td>AI Route Optimization</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr>

                    <tr>
                      <td>Fleet Management</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-error.webp" alt="Yes" /> Limited</td>
                    </tr>

                    <tr>
                      <td>Transportation Management (TMS)</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-no.webp" alt="Yes" /> No</td>
                    </tr>

                    <tr>
                      <td>First-Mile Management</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-no.webp" alt="Yes" /> No</td>
                    </tr>

                    <tr>
                      <td>Middle-Mile Management</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-no.webp" alt="No" /> No</td>
                    </tr>

                    <tr>
                      <td>Last-Mile Management</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr>

                    <tr>
                      <td>Driver Management</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr>

                    <tr>
                      <td>Live GPS Tracking</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr>

                    <tr>
                      <td>Shipment Visibility</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr>

                    <tr>
                      <td>Warehouse Integration</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-error.webp" alt="Yes" /> Via Integrations</td>
                    </tr>

                    <tr>
                      <td>On-Premise Deployment</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-no.webp" alt="Yes" /> No</td>
                    </tr>

                    <tr>
                      <td>White-Label Solution</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-no.webp" alt="Yes" /> No</td>
                    </tr>

                    <tr>
                      <td>Advanced Analytics & Reports</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                      <td><img src="/assets/images/check-icon-yes.webp" alt="Yes" /> Yes</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
